<template>
    <div class="flex flex-column md:p-4 ">
        <div v-if="currentView.type !== 'profile'" class="flex flex-wrap justify-content-between gap-2 mt-3 py-2">
            <div class="flex justify-content-start align-items-center gap-2">
                <img :src="profileImage" class="profile-image" alt="Image" />
                <div class="flex flex-column justify-content-start gap-1">
                    <span class="text-left Paragraph-Medium">{{ student.username }}</span>
                    <span class="Caption">{{ cleanupLables(student.currentEducationLevel) }}</span>
                    <span class="Caption"> {{ cleanupLables(student.nextClass?.classModel) || ' ' }}</span>
                </div>
            </div>

            <div class="flex align-items-center gap-2">
                <Button label="View Profile" class="yellow-button-small" @click="viewStudentProfile(student)" />
                <!-- <Menu :model="menuItems" :popup="true" ref="menu" class="menu-item" /> -->
                <!-- <Button class="menu-button" @click="toggleMenu" aria-haspopup="true" aria-controls="overlay_menu">
                    <i class="pi pi-ellipsis-v"></i>
                </Button> -->
            </div>
        </div>

        <div class="card p-0">
            <div v-if="viewStack.length > 1 && currentView.type !== 'tabs' && currentView.type !== 'profile'" class="mb-4" style="margin-top: 4.2rem;">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer"
                    @click="goBack" />
            </div>

            <div v-if="currentView.type === 'profile'">
                <PublicStudentProfile :inner-map="true" :student-id="profile" />
            </div>

            <Tabs v-if="currentView.type === 'tabs'" v-model:value="activeTab" class="institute-tabs">
                <TabList class="flex flex-column justify-content-center align-items-center w-full">
                    <Tab value="0">Classes Info</Tab>
                    <Tab value="1">Results</Tab>
                </TabList>

                <TabPanels class="p-0">
                    <TabPanel value="0">
                        <ClassInfo :classes="classes" :modules="modules"
                            @view-class="pushView('previous-classes', $event)"
                            @view-info="pushView('view-info', $event)"
                            @refresh-classes="fetchUpcomingClasses" />
                    </TabPanel>

                    <TabPanel value="1">
                        <ResultsInfo :results="results" @add-results="pushView('add-results')"
                            @view-result="pushView('view-result', $event)" />
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <div v-else-if="currentView.type === 'previous-classes'">
                <ClassInfo :classes="previousClasses" :modules="modules" :inPrevious="true"
                    @view-class="pushView('previous-classes', $event)" @view-info="pushView('view-info', $event)" />
            </div>

            <div v-else-if="currentView.type === 'add-results'">
                <AddResults @save-result="saveNewResult" @cancel="goBack" />
            </div>

            <div v-else-if="currentView.type === 'edit-result'">
                <AddResults :result="currentView.data" @save-result="updateExistingResult" @cancel="goBack" />
            </div>

            <div v-else-if="currentView.type === 'view-result'">
                <ResultDetails :result="currentView.data" :studentId="student._id" @back="goBack"
                    @edit-result="pushView('edit-result', $event)" @refresh-results="handleRefreshAndBack" />
            </div>

            <div v-else-if="currentView.type === 'view-info'">
                <ClassInfoDetails :classInstanceId="currentView.data.id" @back="goBack" />
            </div>

            <div v-else-if="currentView.type === 'public-profile'">
                <PublicStudentProfile :student-id="student._id" />
            </div>
        </div>
    </div>
    <ConfirmDialog></ConfirmDialog>
</template>

<script setup>
import Button from "primevue/button";
import { defineProps, onMounted, ref, computed, watchEffect } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import { ConfirmDialog } from "primevue";

import ClassInfo from '@/components/dashboard/tutor/enrolledStudents/classInfo.vue'
import ResultsInfo from '@/components/dashboard/tutor/enrolledStudents/resultsInfo.vue'
import AddResults from "@/components/dashboard/tutor/enrolledStudents/addResults.vue";
import ResultDetails from "@/components/dashboard/tutor/enrolledStudents/resultDetails.vue";
import ClassInfoDetails from '@/components/dashboard/tutor/enrolledStudents/classInfoDetails.vue';
import PublicStudentProfile from '@/views/publicProfile/studentProfile.vue';

import { cleanupLables } from "@/utils/cleanups";
import { notifyError, notifySuccess } from "@/utils/notification";
import { classesByStudent, createResult, updateResult, getStudentResults, previousClassesByStudent } from "@/api/tutor";
import blankProfile from '@/assets/blank-profile.png';
import { generateSignedUrl } from "@/api/storage";

const props = defineProps({
    student: {
        type: Object,
        required: true
    }
});

const viewStack = ref([{ type: "tabs", label: "Dashboard" }]);
const currentView = computed(() => viewStack.value[viewStack.value.length - 1]);
const activeTab = ref('0');

function pushView(type, data = null) {
    viewStack.value.push({ type, data });
}

function goBack() {
    if (viewStack.value.length > 1) {
        viewStack.value.pop();
    }
}

const profileImage = ref(blankProfile);

watchEffect(async () => {
    const filePath = props.student?.profilePhotoURL || props.student?.studentPhotoURL;
    if (filePath && !filePath.includes('local environment')) {
        try {
            profileImage.value = await generateSignedUrl(filePath);
        } catch (e) {
            profileImage.value = blankProfile;
        }
    } else {
        profileImage.value = blankProfile;
    }
});

const classes = ref([]);
const previousClasses = ref([]);
const modules = ref([]);
const results = ref([]);
const profile = ref(null);

// const viewProfile = () => {
//     pushView('public-profile');
// }

function viewStudentProfile(student) {
    viewStack.value.push({ type: "profile", label: "Student Profile", data: student });
    console.log(student)
    profile.value = student._id;
}


const fetchUpcomingClasses = async () => {
    try {
        const res = await classesByStudent(props.student._id);
        classes.value = res.data.data || [];
        const subjects = [...new Set(classes.value.map(c => c.subject))].sort();
        modules.value = subjects;
    } catch (e) {
        console.error("Failed to fetch classes", e);
    }
}

const fetchPreviousClasses = async () => {
    try {
        const res = await previousClassesByStudent(props.student._id);
        previousClasses.value = res.data.data || [];
    } catch (e) {
        console.error("Failed to fetch previous classes", e);
    }
}

const fetchStudentResults = async () => {
    try {
        const res = await getStudentResults(props.student._id);
        results.value = res.data.data || [];
    } catch (e) {
        console.error("Failed to fetch results", e);
    }
}

const saveNewResult = async (data) => {
    try {
        await createResult(props.student._id, data);
        notifySuccess("Success!", "Results has been submitted!");
        await fetchStudentResults();
        goBack();
    } catch {
        notifyError("Error!", "Please try again later.")
    }
}

const updateExistingResult = async (data) => {
    try {
        await updateResult(data._id, data);
        notifySuccess("Success!", "Results updated successfully!");
        await fetchStudentResults();
        goBack();
        goBack();
    } catch (error) {
        console.error(error);
        notifyError("Error!", "Failed to update result.")
    }
}

const handleRefreshAndBack = async () => {
    await fetchStudentResults();
    goBack();
}

onMounted(async () => {
    fetchUpcomingClasses();
    fetchPreviousClasses();
    fetchStudentResults();
})
</script>

<style scoped>
:deep(.institute-tabs .p-tab-active) {
    color: #8B5E00 !important;
    border-color: #8B5E00 !important;
}

:deep(.institute-tabs .p-tablist-active-bar) {
    background-color: #8B5E00 !important;
}
</style>